import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import DEFAULT_IMAGE_URL from '../../assets/images/poi-placeholder.png';

const propTypes = {
  isOpen: PropTypes.bool,
  text: PropTypes.string,
  images: PropTypes.array,
  size: PropTypes.number,
};

const defaultProps = {
  size: 16,
};

const Container = styled.div`
  font-size: ${props => props.size}px;
`;
const InnerContainer = styled.div`
  opacity: ${props => props.isOpen ? 1 : 0}
  transform: rotateX(0deg);
  // transform: translateY(30em);
  transition: all 0.5s;
  position: absolute;
  left: 0;
  right: 0;
  top: ${props => props.isOpen ? -29 : 0}em;
  display: flex;
  flex-direction: column;
  padding: 1.25em 1em 1.5em 1em;
  background-color: black;
  width: 30em;
  height: 25em;
  margin: 0.6em auto;
`;
const Header = styled.h2`
  color: white;
  margin: 0;
  padding: 0;
  flex: 0.8;
  font-size: 2em;
`;

const Paragraph = styled.p`
  color: white;
  margin: 0;
  padding: 0;
  flex: ${props => props.noImages ? 5 :3};
  overflow: auto;
  font-size: 1.25em;

::-webkit-scrollbar {
    width: 0.5em;
}
 
::-webkit-scrollbar-track {
    -webkit-border-radius: 10px;
    border-radius: 10px;
}

::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: #686868;
}
`;

const ImagesContainer = styled.div`
  width: 100%;
  display: ${props => props.noImages ? 'none' : 'flex'};
  justify-content: space-between;
  margin: 1.25em 0 0 0;
  flex: 2;
`;

const Image = styled.div`
  background-color: #d1d1d1;
  width: 7.5em;
  height: 7.5em;
  background-image: url(${props => props.src}), url(${DEFAULT_IMAGE_URL});
  background-repeat: no-repeat; 
  background-size: cover;
  background-position: center;
`;

class ExpandingView extends React.Component {
  render() {
    const {
      size,
      isOpen,
      text,
      images,
    } = this.props;

    const layOut = [];
    images && images.forEach((image, inx) => {
      if (layOut.length < 3) {
        layOut.push(
          <Image key={inx} src={image.url} />
        );
      }
    });
    return (
      <Container size={size}>
        <InnerContainer isOpen={isOpen}>
          <Header>Description</Header>
          <Paragraph noImages={!layOut.length}>
            {text}
          </Paragraph>
          <ImagesContainer noImages={!layOut.length}>
            {layOut}
          </ImagesContainer>
        </InnerContainer>
      </Container>
    );
  }
}

ExpandingView.propTypes = propTypes;
ExpandingView.defaultProps = defaultProps;

export default ExpandingView;


// WEBPACK FOOTER //
// ./src/components/PoiDetailsView/ExpandingView.jsx